module.exports = __webpack_public_path__ + "img/reason-rate.58427272.png";